import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populatePrinterFormAction } from '../_state/printerForm.state';
import { PrinterDetailRecord } from '../types/sidecar';

type Props = {
  printer: PrinterDetailRecord | null | undefined;
};

export const usePopulatePrinterForm = ({ printer }: Props) => {
  const populateForm = useSetAtom($populatePrinterFormAction);

  React.useEffect(() => {
    populateForm(printer);
  }, [printer, populateForm]);
};
